import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { UserService } from '../services/user.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireMessaging } from '@angular/fire/messaging';

@Injectable({
  providedIn: 'root',
})
export class MessagingService {
  constructor(
    private user: UserService,
    private angularFireDB: AngularFireDatabase,
    private angularFireAuth: AngularFireAuth,
    private angularFireMessaging: AngularFireMessaging
  ) {
    this.angularFireMessaging.messages.subscribe(
      (_messaging: AngularFireMessaging) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      }
    )
  }

  currentMessage = new BehaviorSubject(null);

  /**
   * update token in firebase database
   *
   * @param userId userId as a key
   * @param token token as a value
   */
  updateToken(userId, token) {
    // we can change this function to request our backend service
    this.angularFireAuth.authState.pipe(take(1)).subscribe(() => {
      const data = {};
      data[userId] = token;
      this.angularFireDB.object('fcmTokens/').update(data)
    });
    // setTimeout(() => {
    this.user.saveUserDevice(userId, token).subscribe();
    // }, 3000);
  }

  /**
   * request permission for notification from firebase cloud messaging
   *
   * @param userId userId
   */

  requestPermission(userId) {
    if (typeof Notification === 'undefined') {
      return;
    }
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        this.angularFireMessaging.requestToken.subscribe({
          next: (token) => {
            this.updateToken(userId, token);
            this.receiveMessage();
          },
          error: (error) => {
            console.error(error);
          }
        });
      }
    });
  }

  /**
   * hook method when new notification received in foreground
   */
  receiveMessage() {
    this.angularFireMessaging.messages.subscribe((payload) => {
      console.log('new message received. ', payload);
      this.currentMessage.next(payload);
    });
  }
}
